import { render, staticRenderFns } from "./GetAccount.vue?vue&type=template&id=2bafbcc2&scoped=true&"
import script from "./GetAccount.vue?vue&type=script&lang=js&"
export * from "./GetAccount.vue?vue&type=script&lang=js&"
import style0 from "./GetAccount.vue?vue&type=style&index=0&id=2bafbcc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bafbcc2",
  null
  
)

export default component.exports